// React
import { useState } from "react";
import PropTypes from "prop-types";

// Components
import { Select } from "../project-create/CreateProject.components";
import Spinner from "../common/Spinner";

// Functions
import { tranStr, translate } from "../../utils/translation";
import { unitOfMeasureList } from "../project-create/CreateProject.functions";
import { hasRoles } from "../../utils/roles";
import isEmpty from "../../validation/is-empty";

// API
import {
  putToggleIsGlobal,
  putToggleIsLocalRegionFactor,
  putDisplayedUnit,
} from "../../api/benchmarking/BenchmarkingAPI";

// Style
import "./BenchmarkingSectionToggle.css";

BenchmarkingSectionToggle.propTypes = {
  isGlobalBenchmarking: PropTypes.any,
  isLocalRegionFactorEnabled: PropTypes.any,
  selectedUnitOfMeasure: PropTypes.any,
  updateState: PropTypes.any,
  linkedBenchmarksIdsParentId: PropTypes.any,
  user: PropTypes.object,
};

export default function BenchmarkingSectionToggle(props) {
  const { isGlobalBenchmarking } = props;
  const { isLocalRegionFactorEnabled } = props;
  const { selectedUnitOfMeasure } = props;
  const { updateState } = props;
  const { linkedBenchmarksIdsParentId } = props;
  const { user } = props;

  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);

  const [errors] = useState({});

  if (hasRoles(user.roles, ["Client"])) {
    return null;
  }

  return (
    <div className="benchmarking-section-toggle">
      <div className="benchmark-create-configuration-modal-content headless">
        <div className="toggle">
          Global Benchmarking{""}
          <i
            className="fas fa-question-circle icon"
            title="Global Benchmarking enables comparison across different regions. It uses Global Location Factors and converts currencies as defined in the parameters."
          ></i>
          {isLoading1 ? (
            <Spinner marginLeft="25px" width="35px"></Spinner>
          ) : (
            <label className="switch">
              <input
                type="checkbox"
                checked={isGlobalBenchmarking}
                onChange={async () => {
                  setIsLoading1(true);
                  await putToggleIsGlobal(linkedBenchmarksIdsParentId);
                  await updateState();
                  setIsLoading1(false);
                }}
              />
              ""{""}
              <span className="slider round"></span>
            </label>
          )}
        </div>
      </div>
      <div className="benchmark-create-configuration-modal-content headless">
        <div className="toggle">
          Local Region Area{""}
          <i
            className="fas fa-question-circle icon"
            title="Local Region Area changes the analysis from a cost/GIA basis to the project's cost/local region area (ie cost/MW, cost/bed, cost/room)"
          ></i>
          {isLoading2 ? (
            <Spinner marginLeft="25px" width="35px"></Spinner>
          ) : (
            <label className="switch">
              <input
                type="checkbox"
                checked={isLocalRegionFactorEnabled}
                onChange={async () => {
                  setIsLoading2(true);
                  await putToggleIsLocalRegionFactor(
                    linkedBenchmarksIdsParentId
                  );
                  await updateState();
                  setIsLoading2(false);
                }}
              />
              ""{""}
              <span className="slider round"></span>
            </label>
          )}
        </div>
      </div>
      {isLoading3 ? (
        <Spinner marginLeft="339px" width="35px"></Spinner>
      ) : (
        <Select
          label={translate("Displayed Unit")}
          placeholder={tranStr("Displayed Unit")}
          value={isEmpty(selectedUnitOfMeasure) ? "" : selectedUnitOfMeasure}
          options={unitOfMeasureList()}
          onChange={async (newUnit) => {
            setIsLoading3(true);
            await putDisplayedUnit(linkedBenchmarksIdsParentId, newUnit);
            await updateState();
            setIsLoading3(false);
          }}
          error={errors.UnitOfMeasure}
        />
      )}
    </div>
  );
}
